import {
  SAVE_STACKUP_FULFILLED,
  INIT_STACKUP,
  RESTORE_STACKUP,
} from '../../actions/action-types';

const initialState = {};

function newStackupSpec(state = initialState, action){
  switch(action.type){
    case SAVE_STACKUP_FULFILLED:
      return action.payload.newStackupSpec;
    case INIT_STACKUP:
      return action.payload.newStackupSpec;
    case RESTORE_STACKUP:
      return action.payload.newStackupSpec;
    default:
      return state;
  }
}

export default newStackupSpec;

export function getDefaultCoreSpec(state){
  return state.core;
}

export function getDefaultPrepregSpec(state){
  return state.prepreg;
}

export function getDefaultInnerCopperSpec(state){
  return { weight: state.innerCopperWeight };
}

export function getDefaultResinId(state) {
  return state.resin ? state.resin.id : -1;
}



// WEBPACK FOOTER //
// ./src/reducers/stackup/newStackupSpec.js